export enum PasswordInputType {
  ClearText = "text",
  MaskedInput = "password"
}
